import type { AppDefinition } from '../types';

/** Qoyod — accounting books. No connector yet. */
export const QOYOD_APP: AppDefinition = {
  id: 'qoyod',
  nameKey: 'apps.qoyod.name',
  descriptionKey: 'apps.qoyod.description',
  logo: '/images/apps/qoyod-logo.png',
  categories: ['accounting'],
  status: 'soon',
  label: 'soon',
};
